// Ширина текста названия тем же шрифтом, что на баре, без рендера в DOM: canvas.measureText, с кэшем.
// Пока веб-шрифт не загружен, canvas меряет запасным — после загрузки функция меняется и кэш другой.
import { useEffect, useMemo, useState } from 'react';

const cache = new Map<string, number>();
let ctx: CanvasRenderingContext2D | null | undefined;

function titleMeasurer(loaded: boolean): (s: string) => number {
  if (ctx === undefined) ctx = document.createElement('canvas').getContext('2d');
  const font = `700 14px ${getComputedStyle(document.body).fontFamily}`;
  if (ctx) ctx.font = font;
  const prefix = (loaded ? 'L' : 'F') + font + '|';
  return (s) => {
    const key = prefix + s;
    let w = cache.get(key);
    if (w === undefined) { w = ctx ? ctx.measureText(s).width : s.length * 8; cache.set(key, w); }
    return w;
  };
}

export function useTitleMeasurer(): (s: string) => number {
  const [loaded, setLoaded] = useState(() => document.fonts.status === 'loaded');
  useEffect(() => { if (!loaded) void document.fonts.ready.then(() => setLoaded(true)); }, [loaded]);
  return useMemo(() => titleMeasurer(loaded), [loaded]);
}
